<template>
  <iframe
    class="marmoset-viewer"
    src="about:blank"></iframe>
</template>

<script>
  function generateIFrameHtml(url) {
    // Unforutnately, my editor's syntax highlighter freaks out if you include
    // < /script> inside a string, so we need this janky workaround.
    const script = 'script';
    return `
      <html>
        <head>
          <style>
            html, body {
              margin: 0;
              padding: 0;
            }
            body > div,
            body > div > * {
              position: absolute;
              top: 0;
              left: 0;
              width: 100% !important;
              height: 100% !important;
            }
          </style>
        </head>
        <body>
          <${script} src="https://viewer.marmoset.co/main/marmoset.js"></${script}>
          <${script}>
            const w = window.innerWidth;
            const h = window.innerHeight;
            const viewer = new marmoset.WebViewer(w, h, '${url}');
            function onResize() {
              const w = window.innerWidth;
              const h = window.innerHeight;
              viewer.resize(w, h);
            }
            viewer.onLoad = onResize;
            window.addEventListener('resize', onResize, true);
            document.body.appendChild(viewer.domRoot);
          </${script}>
        </body>
      </html>
    `;
  }

  export default {
    name: 'marmoset-viewer',

    props: ['src'],

    data() {
      return {};
    },

    mounted() {
      this.loadViewer();
    },

    methods: {
      loadViewer() {
        const html = generateIFrameHtml(this.src);
        const iframe = this.$el;
        iframe.contentDocument.open();
        iframe.contentDocument.write(html);
        iframe.contentDocument.close();
      },
    },

    watch: {
      src: function() {
        this.loadViewer();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .marmoset-viewer {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// MarmosetViewer.vue?2c0fbc08